export default __webpack_public_path__ + "static/media/background.0353cfc4.png";